import { ComponentPropsWithoutRef, forwardRef } from 'react';

import { cn } from '@components/primitives/utilities';

import css from './styles.module.css';

export const BADGE_VARIANTS = [
  'primary',
  'outline',
  'red',
  'enterprise',
  'dark',
  'warning',
  'success',
  'muted',
] as const;

export const BADGE_SIZES = ['sm', 'md', 'lg'] as const;

export type BadgeVariant = (typeof BADGE_VARIANTS)[number];
export type BadgeSize = (typeof BADGE_SIZES)[number];

export type BadgeProps = ComponentPropsWithoutRef<'span'> & {
  size?: BadgeSize;
  variant?: BadgeVariant;
};

/** Icons are children — the badge already spaces and sizes them per `size`. */
export const Badge = forwardRef<HTMLSpanElement, BadgeProps>(function Badge(
  { children, className, size = 'md', variant = 'primary', ...props },
  ref
) {
  return (
    <span
      {...props}
      ref={ref}
      className={cn(css.badge, className)}
      data-size={size}
      data-variant={variant}
    >
      {children}
    </span>
  );
});
